// Слайдер наклона/поворота: подпись + живой отсчёт в градусах + три засечки.
// Порт ref (SubBlockSettingsEditor: наклон текста и поворот картинки) — разметка
// одна на оба элемента, различаются только подпись и предел.
import { Label, Slider } from '@teach/ui'

interface Props {
  label: string
  value: number
  /** Предел в градусах: слайдер идёт от -limit до +limit. */
  limit: number
  onChange: (value: number) => void
}

const deg = (v: number): string => (v > 0 ? `+${v}°` : `${v}°`)

export const RotationSlider = ({ label, value, limit, onChange }: Props) => (
  <div className="space-y-3">
    <div className="flex items-center justify-between">
      <Label className="text-xs text-muted-foreground">{label}</Label>
      <span className="text-xs font-medium">{deg(value)}</span>
    </div>
    <Slider
      value={[value]}
      onValueChange={([v]) => onChange(v)}
      min={-limit}
      max={limit}
      step={1}
    />
    <div className="flex justify-between text-[10px] text-muted-foreground">
      <span>-{limit}°</span>
      <span>0°</span>
      <span>+{limit}°</span>
    </div>
  </div>
)
